import moment from "moment";

export default {
  dtTransfer: {
    label: 'stock.transfer.date',
    type: 'date',
    field: 'dtTransfer',
    render: (date) => moment(date).format('DD/MM/YYYY HH:mm:ss'),
    fixed: false,
  },
  branch: {
    label: 'field.store',
    type: 'general',
    field: 'branch',
    render: true,
    fixed: false,
    disableOrder: true,
  },

  idProduct: {
    label: 'lm_label',
    type: 'general',
    field: 'idProduct',
    render: true,
    fixed: false,
    disableOrder: true,
  },
  dsProduct: {
    label: 'reports.description',
    type: 'general',
    field: 'dsProduct',
    render: true,
    fixed: false,
    disableOrder: true,
  },
  section: {
    label: 'section',
    type: 'general',
    field: 'section',
    render: true,
    fixed: false,
    disableOrder: true,
  },
  idBatch: {
    label: 'stock.transfer.batch',
    type: 'general',
    field: 'idBatch',
    render: true,
    fixed: false,
    disableOrder: true,
  },
  origin: {
    label: 'stock.transfer.origin.list',
    type: 'general',
    field: 'origin',
    render: true,
    fixed: false,
    disableOrder: true,
  },
  destiny: {
    label: 'stock.transfer.destiny.list',
    type: 'general',
    field: 'destiny',
    render: true,
    fixed: false,
    disableOrder: true,
  },
  quantity: {
    label: 'stock.quantity.new',
    type: 'general',
    field: 'quantity',
    render: true,
    fixed: false,
    disableOrder: true,
  },
  qtOriginBefore: {
    label: 'stock.origin.before',
    type: 'general',
    field: 'qtOriginBefore',
    render: true,
    fixed: false,
    disableOrder: true,
  },
  qtDestinyBefore: {
    label: 'stock.destiny.before',
    type: 'general',
    field: 'qtDestinyBefore',
    render: true,
    fixed: false,
    disableOrder: true,
  },
  qtOriginAfter: {
    label: 'stock.origin.after',
    type: 'general',
    field: 'qtOriginAfter',
    render: true,
    fixed: false,
    disableOrder: true,
  },
  qtDestinyAfter: {
    label: 'stock.destiny.after',
    type: 'general',
    field: 'qtDestinyAfter',
    render: true,
    fixed: false,
    disableOrder: true,
  },
  ldapWithName: {
    label: 'ldap.with.name',
    type: 'general',
    field: 'ldapWithName',
    render: true,
    fixed: false,
    disableOrder: true,
  },
  fullLdapApprover: {
    label: 'ldap.with.approver.name',
    type: 'general',
    field: 'fullLdapApprover',
    render: true,
    fixed: false,
    disableOrder: true,
  },
  statusName: {
    label: 'Status',
    field: 'statusName',
    align: 'left',
    type: 'general',
    customWidth: 180,
    fixed: false,
    render: true,
    disableOrder:true
  },
  dtApproval: {
    label: 'stock.transfer.approval.date',
    type: 'date',
    field: 'dtApproval',
    render: (date) => moment(date).format('DD/MM/YYYY HH:mm:ss'),
    fixed: false,
  },
  requestLog: {
    label: 'stock.transfer.integrated',
    type: 'general',
    field: 'integrated',
    render: true,
    fixed: false,
    disableOrder: true,
  },
}
